import { ValidationError } from '../../error';
import { CurrencyUnit } from '../Currency/Currency.types';

// EU only
export const EU_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
] as const;

// Add-ons: UK, US, LI (Lichtenstein), CH (Switzerland)
export const EXTRA_COUNTRIES = ['CH', 'LI', 'GB', 'US'] as const;

export const ACCEPTED_COUNTRY_CODES = [
  ...EU_COUNTRIES,
  ...EXTRA_COUNTRIES,
] as const;

export const CLEARED_COUNTRY_CODES = [
  'US',
  'GB',
  'CH',
  'FR',
  'AT',
  'SE',
  'IT',
  'ES',
  'DE',
] as const;

export type AcceptedCountry = (typeof ACCEPTED_COUNTRY_CODES)[number];

export const isEUCountry = (c: unknown): c is (typeof EU_COUNTRIES)[number] =>
  typeof c === 'string' &&
  EU_COUNTRIES.includes(c as (typeof EU_COUNTRIES)[number]);

export enum CountryCode {
  US = 'US',
  UK = 'GB',
  EU = 'EU',
}

//TODO: need to fix this if we have an intention of using it, delete if not
export const CurrencyCountryCodeMap: Record<CurrencyUnit, CountryCode> = {
  [CurrencyUnit.USD]: CountryCode.US,
  [CurrencyUnit.EUR]: CountryCode.UK,
  [CurrencyUnit.GBP]: CountryCode.UK,
  [CurrencyUnit.CHF]: CountryCode.UK,
  [CurrencyUnit.SEK]: CountryCode.UK,
};

export function isValidCountryCode(
  value: unknown,
): asserts value is CountryCode {
  switch (value) {
    case CountryCode.US:
    case CountryCode.UK:
      return;
    default:
      throw new ValidationError(value, 'countryCode', [
        `error validating CountryCode: received ${JSON.stringify(value)}`,
      ]);
  }
}

export const stringToCountryCode = (str: string): CountryCode | null => {
  if (typeof str !== 'string') return null;

  switch (str.toLowerCase()) {
    case 'us':
    case 'en-us':
      return CountryCode.US;
    case 'uk':
    case 'en-gb':
      return CountryCode.UK;
    default:
      return null;
  }
};
